import { render, staticRenderFns } from "./vipexpire.vue?vue&type=template&id=3a2978a4&scoped=true"
import script from "./vipexpire.vue?vue&type=script&lang=js"
export * from "./vipexpire.vue?vue&type=script&lang=js"
import style0 from "./vipexpire.vue?vue&type=style&index=0&id=3a2978a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2978a4",
  null
  
)

export default component.exports